import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import logout from '../Components/Image/logout.png'
import { Form, Button, InputGroup, FormControl, Card } from 'react-bootstrap';
import TableComp from '../Components/ReusableTable'
import { connect } from 'react-redux'
import {
  getSupplierPOs,
  getPOPurchaseOrders,
} from '../store/actions/supplierActions'
import SearchBar from '../Components/SearchBar'
import DropdownFlat from '../Components/DropdownFlat'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Modal from '../Components/CustomModal'
import ModalHeader from '../Components/ModalHeader'
import ModalBody from '../Components/ModalBody'
import ModalFooter from '../Components/ModalFooter'
import FileVersionModal from '../Components/FileVersionModal';
import PoDocumentRevisePopUp from '../Components/PoDocumentRevisePopUp';
import { GetDocumentsForAdvance, postDocumentIDForPODetailsDocument, getPOSearch, UpdatePoStatusforPOacceptanceRequest, getSearchedPO, GetExcellExportData, getProjectAllocationByUserId, getQAActivity, postNonPODetails } from '../store/actions/poDetailsActions';
import { SetFlag, GetFilterList } from '../store/actions/masterActions'
import { uploadFileGeneric } from '../store/actions/fileActions';
import env from '../ENV';
import AuthHandlerInstance from '../Classes/AuthHandler'
import swal from '@sweetalert/with-react';
import toast from 'react-hot-toast';
import numberWithCommas from '../Classes/NumberwithComma'
import dateFormater from '../Classes/FormatDate'
import PaginationComponent from '../Components/PaginationComponent';
import Loading from '../Components/Loader';
import RejectPOAcceptance from '../Components/RejectPOAcceptance';
import POCommentPopUp from '../Components/POCommentPopUp';
import Select, { components } from "react-select"
import formatDate from '../Classes/FormatDateTimeInIST';
import formatTime from '../Classes/FormatTime';
import CurrencyInput from 'react-currency-input-field';
// import { CSVLink } from "react-csv";

const FILESERVER_ROOT_URL = env.FILE_SERVER_URL;

// function formatDate(date) {
//     var d = new Date(date),
//     month = '' + (d.getMonth() + 1),
//     day = '' + d.getDate(),
//     year = d.getFullYear();

//     if (month.length < 2) 
//     month = '0' + month;
//     if (day.length < 2) 
//     day = '0' + day;

//     return [day, month, year].join('-');
//   }


class Dashboard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      supplierName: "",
      select: false,
      checkbox: false,
      modal: false,
      OpenVersionmodal: false,
      OpenVersionUploadPopUp: false,
      opacity: "",
      selectAll: false,
      selected: [],
      uploadedId: null,
      poRowData: {},
      checkedArray: [],
      Date: [
        { value: 1, label: "Ascending" },
        { value: 2, label: "Descending" }],
      selected: [],
      indexCounter: 0,
      selectedFile: [],
      files: {},
      paymentTerm: ["Y009", "Y026"],
      searchTerm: new URLSearchParams(this.props.location.search).get("searchTerm") ? new URLSearchParams(this.props.location.search).get("searchTerm") : "",
      tableData: [],
      currentPage: new URLSearchParams(this.props.location.search).get("currentPage") ? new URLSearchParams(this.props.location.search).get("currentPage") : 1,
      totalPos: 0,
      posPerpage: new URLSearchParams(this.props.location.search).get("posPerpage") ? new URLSearchParams(this.props.location.search).get("posPerpage") : 10,
      loading: true,
      ReviseModal: false,
      poId: "",
      uploadId: "",
      flagR: "",
      varPoId: "",
      varDocumentId: "",
      finalvendorlist: [],
      VendorSAPIdS: [],
      finalpos: [],
      finalwbsno: [],
      finalstatus: [],
      finalloc: [],
      finalemployees: [],
      sortByWBS: new URLSearchParams(this.props.location.search).get("sortByWBS") ? (new URLSearchParams(this.props.location.search).get("sortByWBS")).split(',') : [],
      sortByPlantCode: new URLSearchParams(this.props.location.search).get("sortByPlantCode") ? (new URLSearchParams(this.props.location.search).get("sortByPlantCode")).split(',') : [],
      sortByVendor: new URLSearchParams(this.props.location.search).get("sortByVendor") ? (new URLSearchParams(this.props.location.search).get("sortByVendor")).split(',') : [],
      sortByEmployees: new URLSearchParams(this.props.location.search).get("sortByEmployees") ? (new URLSearchParams(this.props.location.search).get("sortByEmployees")).split(',') : [],
      sortByPo: new URLSearchParams(this.props.location.search).get("sortByPo") ? (new URLSearchParams(this.props.location.search).get("sortByPo")).split(',') : [],
      sortByPurchaseGroup: new URLSearchParams(this.props.location.search).get("sortByPurchaseGroup") ? (new URLSearchParams(this.props.location.search).get("sortByPurchaseGroup")).split(',') : [],
      sortByLoc: [],
      sortBy: 'all',
      poDocStartDate: new URLSearchParams(this.props.location.search).get("poDocStartDate") ? new URLSearchParams(this.props.location.search).get("poDocStartDate") : "",
      poDocEndDate: new URLSearchParams(this.props.location.search).get("poDocEndDate") ? new URLSearchParams(this.props.location.search).get("poDocEndDate") : "",
      isShowFilter: false,
      isShowPoDocDate: false,
      searchForOptions: [
        {
          label: 'Currency', value: 'Currency'
        },
        {
          label: 'Location', value: 'Location'
        },
        {
          label: 'Material', value: 'Material'
        },
        {
          label: 'Payment term', value: 'Payment term'
        },
        {
          label: 'Plant Code', value: 'Plant Code'
        },
        {
          label: 'PO Number', value: 'PO Number'
        },
        {
          label: 'Purchase Group', value: 'Purchase Group'
        },
        {
          label: 'Status', value: 'Status'
        },
        {
          label: 'Vendor', value: 'Vendor'
        },
        {
          label: 'Project No.', value: 'WBS'
        },
      ],
      nonPOModal: false,
      searchForItem: [],
      nonPO: {
        POSAPId: "",
        VendorSAPId: "",
        poDepartment: "",
        VendorId: "",
        POCreationDate: "",
        POAmount: "",
        PaymentTermId: "",
        Location: "",
        poStatus: 7,
        incoTerms: "",
        Currency: "",
        PurchaseGroup: "",
        PurchaseGroupDescription: "",
      },
      CurrencyArray: [
        { value: "INR", label: "INR" },
        { value: "EUR", label: "EUR" },
        { value: "USD", label: "USD" },
        { value: "CNY", label: "CNY" }
      ],
      poDepartmentsArray: [
        { value: "HR", label: "HR" },
        { value: "Admin", label: "Admin" },
        { value: "IT", label: "IT" },
        { value: "Finance", label: "Finance" }
      ],
      poPaymentTermsArray: [
        { value: 10, label: "Y009" },
        { value: 27, label: "Y026" },
      ],
      infoTermsArray: [
        { value: "EXW", label: "EXW" },
        { value: "FCA", label: "FCA" },
        { value: "FSA", label: "FSA" },
        { value: "FOB", label: "FOB" },
        { value: "CFR", label: "CFR" },
        { value: "CIF", label: "CIF" },
        { value: "CPT", label: "CPT" },
        { value: "CIP", label: "CIP" },
        { value: "DAP", label: "DAP" },
        { value: "DPU", label: "DPU" },
        { value: "DDP", label: "DDP" },
      ],
      nonPOError: {
        POSAPId: "This is required field",
        poDepartment: "This is required field",
        VendorSAPId: "This is required field",
        POCreationDate: "This is required field",
        POAmount: "This is required field",
        PaymentTermId: "This is required field",
        Location: "This is required field",
        incoTerms: "This is required field",
        Currency: "This is required field",
        PurchaseGroup: "",
        PurchaseGroupDescription: "",
      },
      SelectCurrencyArray: [],
      SelectVendorSapId: [],
      SelectPODepartment: [],
      SelectPOPaymentTerm: [],
      SelectInfoTrems: [],
      searchFor: new URLSearchParams(this.props.location.search).get("searchFor") ? new URLSearchParams(this.props.location.search).get("searchFor") : "",
      csvData: [],
      modalQAActivity: false,
      selectedItem: {},
    }
    // this.handleChange = this.handleChange.bind(this);
    this.modal = this.modal.bind(this);
    this.OpenVersionmodal = this.OpenVersionmodal.bind(this);
    this.OpenSaveVersionFilePopUp = this.OpenSaveVersionFilePopUp.bind(this);
    this.checkboxAll = this.checkboxAll.bind(this);
    this.requestPoAcceptance = this.requestPoAcceptance.bind(this);
    this.dateformate = this.dateformate.bind(this);
    this.ReviseModalPopUp = this.ReviseModalPopUp.bind(this);

  }

  modal() {
    this.setState({ modal: !this.state.modal });

    if (this.state.modal == true) {
      this.setState(
        { opacity: "" }
      )

    }
    else {
      this.setState(
        { opacity: "0.2" }
      )

    }
  }

  // ? open version modal
  async OpenVersionmodal(uploadedId) {
    let versionList = [];
    console.log(uploadedId, "this.state.uploadID")
    let stateVal = this.state.OpenVersionmodal;
    this.setState({ OpenVersionmodal: !stateVal, uploadedId: uploadedId });
  }

  filterData = async (currentPage = 1) => {
    console.log(this.props.history.location.pathname, 'this.props.history')
    await this.setState({ loading: true })
    let tableData = []
    let totalPos = 0
    let searchData = {
      currentPage: currentPage,
      posPerpage: this.state.posPerpage,
      searchTerm: this.state.searchTerm,
      sortByEmployees: this.state.sortByEmployees,
      sortByPlantCode: this.state.sortByPlantCode,
      sortByWBS: this.state.sortByWBS,
      sortByPo: this.state.sortByPo,
      sortByPurchaseGroup: this.state.sortByPurchaseGroup,
      sortByVendor: this.state.sortByVendor,
      sortBy: this.state.sortBy,
      poDocStartDate: this.state.poDocStartDate,
      poDocEndDate: this.state.poDocEndDate,
      searchFor: this.state.searchFor,
      paymentTerm: this.props.history.location.pathname && (this.props.history.location.pathname).includes('hr-admin-purchase-orders') ? this.state.paymentTerm : [],
    }
    this.props.history.push({
      pathname: this.props.history.location.pathname,
      search: "?" + new URLSearchParams(searchData).toString()
    })

    await this.props.getPOSearch(searchData)
    if (this.props.poDetails && this.props.poDetails.poSearch && 'pos' in this.props.poDetails.poSearch) {
      tableData = this.props.poDetails.poSearch.pos
      totalPos = this.props.poDetails.poSearch.pageinfo.totalcount
    }

    var nonPO = {
      POSAPId: "",
      VendorSAPId: "",
      poDepartment: "",
      VendorId: "",
      POCreationDate: "",
      POAmount: "",
      PaymentTermId: "",
      Location: "",
      poStatus: 7,
      incoTerms: "",
      Currency: "",
      PurchaseGroup: "",
      PurchaseGroupDescription: "",
    }
    var nonPOError = {
      POSAPId: "This is required field",
      poDepartment: "This is required field",
      VendorSAPId: "This is required field",
      POCreationDate: "This is required field",
      POAmount: "This is required field",
      PaymentTermId: "This is required field",
      Location: "This is required field",
      incoTerms: "This is required field",
      Currency: "This is required field",
      PurchaseGroup: "",
      PurchaseGroupDescription: "",
    }
    await this.setState({ tableData, totalPos, loading: false, selectedFile: [], checkedArray: [], select: false, nonPO: nonPO, nonPOError: nonPOError, selectedCurrency: [], SelectInfoTrems: [], SelectPODepartment: [], SelectVendorSapId: [], SelectPOPaymentTerm: [] })
  }

  dataSync = async () => {
    let roles = AuthHandlerInstance.getRoles()
    let userId = AuthHandlerInstance.getUserID()
    if (roles[12]) {
      let sortByWBS = []
      let WBSCode = []
      await this.props.getProjectAllocationByUserId({ UserId: userId })
      let ProjectCodes = await this.props.poDetails.getProjectAllocationByUserId
      if (ProjectCodes.length > 0) {
        ProjectCodes.map((elem) => {
          sortByWBS.push(elem.ProjectCode)
          WBSCode.push({ label: elem.ProjectCode, value: elem.ProjectCode })
        })
      }
      await this.setState({ sortByWBS, WBSCode })
    }
    await this.filterData(this.state.currentPage)
    // await this.props.GetExcellExportData()
    // let csvData = []
    // await this.props.poDetails.excelData[0].map(async (data) => {
    //   let Projectcode = data.ProjectCode ? data.ProjectCode.includes('ET') ? (data.ProjectCode).slice(0, 11) : (data.ProjectCode).slice(0, 6) : ''
    //   await csvData.push({
    //     "POSAPId": data.POSAPId,
    //     "ProjectCode": Projectcode,
    //     "PlantCode": data.PlantCode,
    //     "PurchaseGroup": data.PurchaseGroup,
    //     "VendorSapId": data.VendorSapId,
    //     "VendorName": data.VendorName,
    //     "PaymentTermCode": data.PaymentTermCode,
    //     "Currency": data.Currency,
    //     "POAmount": data.POAmount,
    //     "Location": data.Location,
    //     "PO Creation Date": data.POCreationDate ? dateFormater(data.POCreationDate) : "",
    //     "Stat. Delivery Date": data.PODeliveryDate ? dateFormater(data.PODeliveryDate) : "",
    //     "Status": data.POLineItemSAPCode == null && data.PlantCode ? "PO Cancelled" : data.TrnStatusName
    //   })
    // }) // to get the PO Data for download
    // await this.setState({ csvData })
    // console.log(this.state.csvData, "css========>")
  }

  getFilterList = async () => {
    await this.props.GetFilterList()
    let finalvendorlist = []
    let finalpos = []
    let finalwbsno = []
    let finalplantcode = []
    let finalemployees = []
    let finalPurchaseGroup = []
    let VendorSAPIdS = []
    await finalemployees.push({ label: `Open`, value: 'opened' })
    await this.props.filterList[0].map(async (item) => {
      await finalemployees.push({ label: `${item.EmployeeName}`, value: item.EmployeeName })
    })
    await this.props.filterList[1].map(async (item) => {
      await finalplantcode.push({ label: item.PlantCode, value: item.PlantCode })
    })
    await this.props.filterList[2].map(async (item) => {
      await finalwbsno.push({ label: item.WBSCode, value: item.WBSCode })
    })
    await this.props.filterList[3].map(async (item) => {
      await finalvendorlist.push({ label: item.VendorName, value: item.VendorName })
      await VendorSAPIdS.push({ label: item.VendorSapId, value: item.VendorSapId, VendorName: item.VendorName, VendorId: item.VendorId, VendorLocation: item.VendorLocation })
    })
    await this.props.filterList[4].map(async (item) => {
      await finalpos.push({ label: item.POSAPId, value: item.POSAPId })
    })
    await this.props.filterList[9].map(async (item) => {
      await finalPurchaseGroup.push({ label: item.PurchaseGroup, value: item.PurchaseGroup })
    })

    let POSAPId = []
    let WBSCode = []
    let PlantCode = []
    let PurchaseGroup = []
    let VendorName = []
    let searchForItem = []
    await this.state.sortByPlantCode.map(async (item) => {
      await PlantCode.push({ label: item, value: item })
    })
    await this.state.sortByWBS.map(async (item) => {
      await WBSCode.push({ label: item, value: item })
    })
    await this.state.sortByPo.map(async (item) => {
      await POSAPId.push({ label: item, value: item })
    })
    await this.state.sortByVendor.map(async (item) => {
      await VendorName.push({ label: item, value: item })
    })
    await this.state.sortByPurchaseGroup.map(async (item) => {
      await PurchaseGroup.push({ label: item, value: item })
    })
    if (this.state.searchFor) {
      await searchForItem.push({ label: this.state.searchFor, value: this.state.searchFor })
    }

    await this.setState({ finalvendorlist, VendorSAPIdS, finalpos, finalwbsno, finalplantcode, finalemployees, PlantCode, WBSCode, POSAPId, VendorName, searchForItem, finalPurchaseGroup, PurchaseGroup })
  }
  componentDidMount = async () => {
    // this.props.getSupplierPOs(1);
    await this.dataSync()
    await this.getFilterList()
  }

  handleSelectPO = async (e) => {
    let sortByPo = []
    let POSAPId = []
    if (e.length > 0) {
      e.map((item) => {
        sortByPo.push(item.value)
        POSAPId.push(item)
      })
    }
    await this.setState({ sortByPo, POSAPId })
    await this.filterData()
  }
  handleSelectPurchaseGroup = async (e) => {
    let sortByPurchaseGroup = []
    let PurchaseGroup = []
    if (e.length > 0) {
      e.map((item) => {
        sortByPurchaseGroup.push(item.value)
        PurchaseGroup.push(item)
      })
    }
    await this.setState({ sortByPurchaseGroup, PurchaseGroup })
    await this.filterData()
  }
  handleSelectWBS = async (e) => {
    let sortByWBS = []
    let WBSCode = []
    if (e.length > 0) {
      e.map((item) => {
        sortByWBS.push(item.value)
        WBSCode.push(item)
      })
    }
    await this.setState({ sortByWBS, WBSCode })
    await this.filterData()
  }
  handleSelectLoc = async (e) => {
    let sortByLoc = []
    if (e.length > 0) {
      e.map((item) => {
        sortByLoc.push(item.value)
      })
    }
    await this.setState({ sortByLoc })
    // console.log(this.state.sortByLoc, "JJJJ")
  }

  handleSelectEmployees = async (e) => {
    let sortByEmployees = []
    let sortBy = 'all'
    let employees = []
    if (e.length > 0) {
      e.map((item) => {
        if (item.value !== 'opened') {
          sortByEmployees.push(item.value)
        } else {
          sortBy = 'opened'
        }
        employees.push(item)
      })
    }
    await this.setState({ sortByEmployees, employees, sortBy })
    await this.filterData()
  }

  handleSelectPlantCode = async (e) => {
    let sortByPlantCode = []
    let PlantCode = []
    if (e.length > 0) {
      e.map((item) => {
        sortByPlantCode.push(item.value)
        PlantCode.push(item)
      })
    }
    await this.setState({ sortByPlantCode, PlantCode })
    await this.filterData()
  }

  handleSelectVendor = async (e) => {
    let sortByVendor = []
    let VendorName = []
    if (e.length > 0) {
      e.map((item) => {
        sortByVendor.push(item.value)
        VendorName.push(item)
      })
    }
    await this.setState({ sortByVendor, VendorName })
    await this.filterData()
  }

  handleSelectPoPerPage = async (e) => {
    await this.setState({ posPerpage: e.value })
    await this.filterData()
  }

  handleSelectSearchFor = async (value) => {
    let searchFor = value
    let searchForItem = [
      {
        label: value, value: value
      }
    ]
    await this.setState({ searchFor, searchForItem })
  }


  handlepoDocStartDate = async (e) => {
    await this.setState({ poDocStartDate: e.target.value })
    await this.filterData()
  }
  handlepoDocEndDate = async (e) => {
    await this.setState({ poDocEndDate: e.target.value })
    await this.filterData()
  }
  toggleFilter = async () => {
    this.setState({ isShowFilter: !this.state.isShowFilter })
  }
  clearFilter = async () => {
    await this.setState({
      isShowFilter: false,
      currentPage: 1,
      posPerpage: 10,
      searchTerm: '',
      sortByEmployees: [],
      sortByPlantCode: [],
      sortByPurchaseGroup: [],
      sortByWBS: [],
      sortByPo: [],
      sortByVendor: [],
      sortBy: 'all',
      poDocStartDate: '',
      poDocEndDate: '',
      searchFor: '',
      POSAPId: [],
      PurchaseGroup: [],
      WBSCode: [],
      PlantCode: [],
      VendorName: [],
      searchForItem: [],
    })
    await this.filterData()
  }
  togglePoDocDate = async () => {
    this.setState({ isShowPoDocDate: !this.state.isShowPoDocDate })
  }

  CheckBox() {

    this.setState({ select: true })
    console.log("select", this.state.checkbox)
    // console.log(this.state.select)

  }

  changeCheckBoxStatus(index) {
    var checkedArray = this.state.checkedArray
    let selected = this.state.selected;
    let status = index in selected ? !selected[index] : true
    selected[index] = status
    if (!checkedArray.includes(index)) {
      checkedArray.push(index)
    } else {
      checkedArray = checkedArray.filter(item => item != index)
    }
    console.log(checkedArray, "checkedArray::")
    this.setState({ selected: selected, checkedArray });
  }

  checkboxAll = async () => {
    let selected = this.state.selected;
    let select = !this.state.select;
    var checkedArray = []
    await this.state.tableData.map(async (item, index) => {
      if (item.TrnStatusID == 1 && item.uploadId !== null) {
        if (select == true) {
          await checkedArray.push(item.PurchaseOrderId)
        } else {
          checkedArray = []
        }
      }

    });
    await this.setState({ selected: selected, select: select, checkedArray });
  }

  requestPoAcceptance = async () => {
    let checkedArray = this.state.checkedArray;
    for (let index = 0; index < checkedArray.length; index++) {
      toast.loading('Requesting...', {
        duration: 1000
      });
      await this.props.UpdatePoStatusforPOacceptanceRequest(checkedArray[index], 5);
    }
    await this.filterData(this.state.currentPage)
  }

  dateformate(dateVal) {
    let d = new Date(dateVal);
    return d.toDateString();
  }

  async OpenSaveVersionFilePopUp(rowData, refresh) {
    this.setState({ OpenVersionUploadPopUp: !this.state.OpenVersionUploadPopUp, uploadedId: rowData ? rowData.uploadId : null, poRowData: rowData });

    if (refresh) {
      await this.props.getPOPurchaseOrders();
    }
  }

  // ? handle file input
  handleFileInput(event, rowData) {
    console.log("🚀 ~ file: Advanced-RequestPOAcceptance.js ~ line 170 ~ Dashboard ~ handleFileInput ~ rowData", rowData)
    console.log("🚀 ~ file: Advanced-RequestPOAcceptance.js ~ line 170 ~ Dashboard ~ handleFileInput ~ event", event)
    // console.log(event, rowData, "file input")
    let fileList = [...this.state.selectedFile];
    let fileObjList = this.state.files
    fileObjList[rowData.PurchaseOrderId] = {
      fileInfo: event.target.files[0],
      dataForFile: rowData
    }
    fileList.push(event.target.files[0])
    this.setState({ selectedFile: fileList, files: fileObjList })
    console.log("🚀 ~ file: Advanced-RequestPOAcceptance.js ~ line 176 ~ Dashboard ~ handleFileInput ~ fileList", this.state.selectedFile, this.state.files)


  }

  // ? handle file upload for PO Details Document
  onclickUpload = async (poID) => {
    // console.log(this.state.selectedFile)
    // console.log("uploadID",uploadID, "POID=", poID)

    if (this.state.selectedFile.length < 1) {

      swal("Please upload some valid document", { icon: "error" })

      return false;
    }
    toast.loading('Uploading Files...', {
      duration: 1000
    });
    var para = this.state.files[poID].fileInfo
    console.log("para", para)
    var result = await this.props.uploadFileGeneric([this.state.files[poID].fileInfo], AuthHandlerInstance.getUserID())
    console.log("result", result.results)
    var userID = AuthHandlerInstance.getUserID()
    console.log("🚀 ~ file: Advanced-RequestPOAcceptance.js ~ line 203 ~ Dashboard ~ onclickUpload=async ~ userID", userID)
    var documentId = result.results[0].DocumentId
    var params = {
      DocumentId: documentId,
      PoID: poID,
      UploadedBy: userID
    }
    await this.props.postDocumentIDForPODetailsDocument(params)
    await this.filterData(this.state.currentPage)
  }


  // ? handle search input
  handleISearch = (e) => {
    let searchTerm = e.target.value
    this.setState({
      searchTerm
    })
    console.log(this.state.searchTerm)
  }
  // ? handle searching
  handleSearching = async () => {
    await this.filterData()
  }
  handleClick = async (event) => {
    let currentPage = Number(event.target.id)
    if (!event.target.id) {
      currentPage = event.target.offsetParent.id
    }
    await this.setState({ currentPage })
    await this.filterData(currentPage)
  }

  ReviseModalPopUp(item, flagR) {
    let poId = item.PurchaseOrderId
    let uploadId = item.uploadId
    this.setState({ ReviseModal: !this.state.ReviseModal, poId, uploadId, flagR });
  }
  setLoader = async (e) => {
    console.log(e, 'loader check')
    this.setState({ loading: e })
  }

  toggleReviseModal(e) {
    this.setState({ ReviseModal: !this.state.ReviseModal });
  }

  POCommentPopUpModal = async () => {
    await this.setState({ POCommentPopUpModal: !this.state.POCommentPopUpModal });
    await this.setState({ RetentionDocumentsModal: false });
    if (this.state.POCommentPopUpModal == true) {
      await this.setState(
        { opacity: "" }
      )
    }
    else {
      await this.setState(
        { opacity: "0.2" }
      )
    }
  }
  togglePOCommentPopUpModal(e) {
    this.setState({ POCommentPopUpModal: !this.state.POCommentPopUpModal, varPoId: "", varDocumentId: "" });
    if (this.state.POCommentPopUpModal == true) {
      this.setState(
        { opacity: "" }
      )
    }
    else {
      this.setState(
        { opacity: "0.2" }
      )
    }
  }
  rowClick = async (PurchaseOrderId, POAcceptanceDocumentID) => {
    console.log(PurchaseOrderId, POAcceptanceDocumentID, 'incdex')
    await this.setState({ varPoId: PurchaseOrderId, varDocumentId: POAcceptanceDocumentID })
    await this.POCommentPopUpModal()
  }

  modalQAActivity = async (poRowData) => {
    // this.setState({})
    // console.log(poRowData)
    if (poRowData) {
      this.setState({ selectedItem: poRowData })
      await this.props.getQAActivity({
        PurchaseOrderId: poRowData.PurchaseOrderId
      })
    } else {
      this.setState({ selectedItem: {} })
    }
    this.setState({ modalQAActivity: !this.state.modalQAActivity });

    if (this.state.modalQAActivity === true) {
      this.setState(
        { opacity: "" }
      )

    }
    else {
      this.setState(
        { opacity: "0.2" }
      )
      // this.setState({selectedItem:null})

    }
  }

  toggleNonPOModal = async () => {
    await this.setState({ nonPOModal: !this.state.nonPOModal })
  }

  handleChangeNonPoDetails = async (e) => {
    let val = e.target.value
    let key = e.target.name
    var nonPOError = { ...this.state.nonPOError }
    if (key === "POSAPId") {
      var regex = /^[1-9]\d{9}$/;
      if (val.length > 0) {
        if (regex.test(val)) {
          nonPOError.POSAPId = "";
          this.setState({ nonPOError });
        } else {
          nonPOError.POSAPId = "Po Number should be in number and 10 digit";
          this.setState({ nonPOError });
        }
      } else {
        nonPOError.POSAPId = "This is required field.";
        this.setState({ nonPOError });
      }
    }
    if (key === "VendorSAPId") {
      var regex = /^[1-9]\d{8}$/;
      if (val.length > 0) {
        if (regex.test(val)) {
          nonPOError.VendorSAPId = "";
          this.setState({ nonPOError });
        } else {
          nonPOError.VendorSAPId = "Vendor Code should be in number and 9 digit";
          this.setState({ nonPOError });
        }
      } else {
        nonPOError.VendorSAPId = "This is required field.";
        this.setState({ nonPOError });
      }
    }
    if (key === "PurchaseGroup") {
      if (val.length > 0) {
        nonPOError.PurchaseGroup = "";
        this.setState({ nonPOError });
      } else {
        nonPOError.PurchaseGroup = "This is required field.";
        this.setState({ nonPOError });
      }
    }
    if (key === "PurchaseGroupDescription") {
      if (val.length > 0) {
        nonPOError.PurchaseGroupDescription = "";
        this.setState({ nonPOError });
      } else {
        nonPOError.PurchaseGroupDescription = "This is required field.";
        this.setState({ nonPOError });
      }
    }
    if (key === "incoTerms") {
      if (val.length > 0) {
        nonPOError.incoTerms = "";
        this.setState({ nonPOError });
      } else {
        nonPOError.incoTerms = "This is required field.";
        this.setState({ nonPOError });
      }
    }
    if (key === "POCreationDate") {
      if (val.length > 0) {
        nonPOError.POCreationDate = "";
        this.setState({ nonPOError });
      } else {
        nonPOError.POCreationDate = "This is required field.";
        this.setState({ nonPOError });
      }
    }
    if (key === "Location") {
      if (val.length > 0) {
        nonPOError.Location = "";
        this.setState({ nonPOError });
      } else {
        nonPOError.Location = "This is required field.";
        this.setState({ nonPOError });
      }
    }
    let obj = { ...this.state.nonPO, [key]: val }
    await this.setState({ nonPO: obj })
  }

  handlvalueText = async (value, name) => {
    var nonPOError = { ...this.state.nonPOError }
    console.log(value, name)
    if (name === "POAmount") {
      if (value.length > 0) {
        nonPOError.POAmount = "";
        this.setState({ nonPOError });
      } else {
        nonPOError.POAmount = "This is required field.";
        this.setState({ nonPOError });
      }
    }
    let obj = { ...this.state.nonPO, [name]: value }
    this.setState({ nonPO: obj })
  }

  handleSelectCurrency = async (e) => {
    let selectedCurrency = e.value
    let SelectCurrencyArray = []
    SelectCurrencyArray.push(e)
    let obj = { ...this.state.nonPO, ['Currency']: e.value }
    var nonPOError = { ...this.state.nonPOError }
    nonPOError.Currency = "";
    await this.setState({ selectedCurrency, SelectCurrencyArray, nonPO: obj, nonPOError })
  }

  handleSelectVendorSAPID = async (e) => {
    console.log(e, 'handleSelectVendorSAPID')
    let SelectVendorSapId = []
    SelectVendorSapId.push(e)
    let obj = { ...this.state.nonPO, ['VendorSAPId']: e.value, ['VendorId']: e.VendorId, ['Location']: e.VendorLocation }
    var nonPOError = { ...this.state.nonPOError }
    nonPOError.VendorSAPId = "";
    nonPOError.Location = "";
    await this.setState({ SelectVendorSapId, nonPO: obj, nonPOError })
  }

  handleSelectPODepartment = async (e) => {
    let SelectPODepartment = []
    SelectPODepartment.push(e)
    let obj = { ...this.state.nonPO, ['poDepartment']: e.value }
    var nonPOError = { ...this.state.nonPOError }
    nonPOError.poDepartment = "";
    await this.setState({ SelectPODepartment, nonPO: obj, nonPOError })
  }

  handleSelectPOPaymentTerm = async (e) => {
    let SelectPOPaymentTerm = []
    SelectPOPaymentTerm.push(e)
    let obj = { ...this.state.nonPO, ['PaymentTermId']: e.value }
    var nonPOError = { ...this.state.nonPOError }
    nonPOError.PaymentTermId = "";
    await this.setState({ SelectPOPaymentTerm, nonPO: obj, nonPOError })
  }

  handleSelectInfoTerms = async (e) => {
    let SelectInfoTrems = []
    SelectInfoTrems.push(e)
    let obj = { ...this.state.nonPO, ['incoTerms']: e.value }
    var nonPOError = { ...this.state.nonPOError }
    nonPOError.incoTerms = "";
    await this.setState({ SelectInfoTrems, nonPO: obj, nonPOError })
  }

  handleSubmitNonPODetails = async () => {
    let valid = true;
    if (!('POSAPId' in this.state.nonPO) || (this.state.nonPO.POSAPId == '')) {
      swal("Please Enter Valid PO Number", { icon: "error" })
      return false;
    }
    var regex = /^[1-9]\d{9}$/;
    if (this.state.nonPO.POSAPId.length > 0) {
      if (!regex.test(this.state.nonPO.POSAPId)) {
        swal("Po Number should be in number and 10 digit", { icon: "error" })
        return false;
      }
    }
    if (!('poDepartment' in this.state.nonPO) || (this.state.nonPO.poDepartment == '')) {
      swal("Please Select Valid PO Department", { icon: "error" })
      return false;
    }
    if (!('PaymentTermId' in this.state.nonPO) || (this.state.nonPO.PaymentTermId == '')) {
      swal("Please Select Valid Payment Term", { icon: "error" })
      return false;
    }
    if (!('POAmount' in this.state.nonPO) || (this.state.nonPO.POAmount == '')) {
      swal("Please Enter Valid PO Amount", { icon: "error" })
      return false;
    }
    if (!('VendorSAPId' in this.state.nonPO) || (this.state.nonPO.VendorSAPId == '')) {
      swal("Please Select Valid Vendor Code", { icon: "error" })
      return false;
    }
    if (!('Currency' in this.state.nonPO) || (this.state.nonPO.Currency == '')) {
      swal("Please Select Valid Currency", { icon: "error" })
      return false;
    }
    if (!('POCreationDate' in this.state.nonPO) || (this.state.nonPO.POCreationDate == '')) {
      swal("Please Enter Valid POCreationDate", { icon: "error" })
      return false;
    }
    // if (!('PurchaseGroup' in this.state.nonPO) || (this.state.nonPO.PurchaseGroup == '')) {
    //   swal("Please Enter Valid PurchaseGroup", { icon: "error" })
    //   return false;
    // }
    // if (!('PurchaseGroupDescription' in this.state.nonPO) || (this.state.nonPO.PurchaseGroupDescription == '')) {
    //   swal("Please Enter Valid PurchaseGroupDescription", { icon: "error" })
    //   return false;
    // }
    if (!('incoTerms' in this.state.nonPO) || (this.state.nonPO.incoTerms == '')) {
      swal("Please Enter Valid Inco Temrs", { icon: "error" })
      return false;
    }
    if (!('Location' in this.state.nonPO) || (this.state.nonPO.Location == '')) {
      swal("Please Enter Valid Location", { icon: "error" })
      return false;
    }
    if (!valid) {
      console.log(valid)
      swal("Please Fill out the missing fields", { icon: "error" })
      return false;
    }
    let obj = { ...this.state.nonPO }
    await this.props.postNonPODetails(obj)
    if (this.props.nonPODetailsError && this.props.nonPODetailsError.message) {
      console.log(this.props.nonPODetailsError, 'this.props.nonPODetailsError')
      swal(this.props.nonPODetailsError.message, { icon: "error" })
      return;
    }
    await toast.success(`NON PO Details Updated`, {
      duration: 2000
    });
    await this.toggleNonPOModal()
    await this.dataSync()
  }

  render() {
    console.log(this.props.poDetails.poSearch, "|||||||||||||||||||||||||||||||||||||||||||||||")
    // stating pagination
    const { currentPage, posPerpage } = this.state;
    const varPoId = this.state.varPoId
    const varDocumentId = this.state.varDocumentId

    // Logic for displaying todos
    const indexOfLastTodo = currentPage * posPerpage;
    const indexOfFirstTodo = indexOfLastTodo - posPerpage;
    const currentTodos = this.state.tableData;
    const filteredTodos = this.state.tableData;
    // fetching user roles here
    var roles = AuthHandlerInstance.getRoles()
    console.log("Role of user", roles)

    const customStyles = {
      option: (provided, state) => ({
        ...provided,
        borderBottom: '1px dotted pink',
        //   color: state.isSelected ? 'red' : 'blue',
        padding: "2px 10px",
      }),
      menu: (provided, state) => ({
        ...provided,
        width: "100%",
        minWidth: "max-content",
        zIndex: "999 !important",
      }),
    }

    const tableConstants = () => {
      return [
        {
          title: <input type="checkbox" name="checked" checked={this.state.select} onChange={this.checkboxAll} />
          ,
          render:
            rowData => {

              return (

                <div>
                  <input type="checkbox" name="checked" checked={this.state.checkedArray.includes(rowData.PurchaseOrderId) ? true : false} value=""
                    onChange={(event) => {
                      this.changeCheckBoxStatus(rowData.PurchaseOrderId)
                    }
                    }
                    hidden={rowData.TrnStatusID == 1 && rowData.uploadId !== null ? false : true}
                  />
                </div>
              )
            },
        },
        {
          title: 'PO Number',
          render: rowData => {
            return <span>{(rowData.poDepartment ? (rowData.poDepartment + "-") : "") + rowData.POSAPId}</span>;
          },
        },
        {
          title: 'Project Code',
          render: rowData => {
            return <span>{rowData.ProjectCode ? rowData.ProjectCode.includes('ET') ? (rowData.ProjectCode).slice(0, 11) : (rowData.ProjectCode).slice(0, 6) : ""}</span>;
          },
        },
        {
          title: 'Plant Code',
          render: rowData => {
            return <span>{rowData.PlantCode ? rowData.PlantCode : ""}</span>;
          },
        },
        {
          title: 'Purchase Group',
          render: rowData => {
            return <span>{rowData.PurchaseGroup}</span>;
          },
        },
        {
          title: 'Vendor',
          render: rowData => {
            return <span>{rowData.VendorName}</span>;
          },
        },
        {
          title: 'Currency',
          render: rowData => {
            return <div className="amount-text"><span >{rowData.Currency}</span></div>;
          },
        },
        {
          title: 'PO Amount',
          render: rowData => {
            return <div className="amount-text"><span >{numberWithCommas(rowData.POAmount.toFixed(2))}</span></div>;
          },
        },

        {
          title: 'Location',
          render: rowData => {
            return <span>{rowData.Location}</span>;
          },
        },

        {
          title: 'Status',
          render: rowData => {
            return <>
              <div className="row">
                <div className="col">
                  {rowData.Version > 0 ?
                    <span>{rowData.isWaivedOff == 1 && rowData.TrnStatusID == 7 ? `Ammended - ${rowData.Version} - ${rowData.TrnStatusName} By Waived Off` : `Ammended - ${rowData.Version} - ${rowData.TrnStatusName}`}</span>
                    : <span>{rowData.isWaivedOff == 1 && rowData.TrnStatusID == 7 ? rowData.TrnStatusName + " By Waived Off" : rowData.TrnStatusName}</span>
                  }
                </div>
              </div>
            </>
          },
        },
        {
          title: 'PO Created On',
          render: rowData => {
            return <div style={{ minWidth: "100px" }}>{rowData.POCreationDate ? dateFormater(rowData.POCreationDate) : ""}</div>
          },
        },
        {
          title: 'Stat. Del. Date',
          render: rowData => {
            return <div style={{ minWidth: "100px" }}>{rowData.PODeliveryDate ? dateFormater(rowData.PODeliveryDate) : ""}</div>
          },
        },
        {
          title: 'Requested On',
          render: rowData => {
            return <div style={{ minWidth: "100px" }}>{rowData.RequestedDate ? dateFormater(rowData.RequestedDate) : ""}</div>
          },
        },

        {
          title: 'PO Documents',
          render: rowData => {
            if (rowData.uploadId == null && roles[15]) {
              if (rowData.IsNonPO == 1) {
                return ""
              } else if (rowData.PaymentTermId == 0 || rowData.PaymentTermId == null) {
                return <span className="badge badge-danger">PaymentTerm Not Linked</span>
              } else if (rowData.lineItems.total == 0 && rowData.IsNonPO === 0) {
                return (
                  <span className="badge badge-danger">PO Cancelled</span>
                )
              } else if (rowData.PlantCode == null && rowData.IsNonPO === 0) {
                return (
                  <span className="badge badge-danger">No PO Line Items</span>
                )
              } else {
                return (
                  <div className="view-button justify-content-between row" >
                    <div className="col-md dark">
                      <input type="file" className="form-control-file form-control-x" onChange={(e) => { this.handleFileInput(e, rowData) }} id="exampleFormControlFile1" />
                    </div>
                    <div className="col-md-2 mr-3">
                      <FontAwesomeIcon icon={"cloud-upload-alt"} onClick={(e) => { this.onclickUpload(rowData.PurchaseOrderId) }} color={"black"} title={"Upload File"} size="lg" />
                    </div>
                  </div>
                )
              }
            }
            else if (rowData.uploadId == null && roles[5]) {
              return (
                <div className="view-button">
                  <span className="badge badge-danger" style={{ marginTop: "12px" }}>To Be Uploaded</span>
                </div>
              )
            }
            else if (rowData.uploadId != null && roles[15]) {
              return (
                <div className="view-button" style={{ width: "150px" }}>
                  <a href={FILESERVER_ROOT_URL + "files/Documents/" + rowData.uploadId + "/download"} target="_blank" download>
                    <FontAwesomeIcon icon={"file-download"} color={rowData.uploadId == null || rowData.uploadId == 0 ? "grey" : "black"} title={rowData.uploadId == null || rowData.uploadId == 0 ? "Unavailable" : "Download"} size="lg" />
                  </a>
                  {rowData.lineItems.total != 0 ? rowData.poStatus == 1 ?
                    <FontAwesomeIcon className="ml-3" icon={"cloud-upload-alt"} color="black" title="Upload" size="lg" onClick={() => this.ReviseModalPopUp(rowData, 9)} />
                    : rowData.Version > 0 && rowData.Ammended == 0 ?
                      <FontAwesomeIcon className="ml-3" icon={"cloud-upload-alt"} color="black" title="Upload" size="lg" onClick={() => this.ReviseModalPopUp(rowData, 2)} />
                      : null : null}
                  <FontAwesomeIcon className={"ml-3"} icon={"code-branch"} color={"black"} title="Document Version" size="lg" onClick={() => this.OpenVersionmodal(rowData.uploadId)} />
                  <FontAwesomeIcon className="ml-3" icon={"sms"} color={"block"} title="Comments" size="lg" onClick={() => this.rowClick(rowData.PurchaseOrderId, rowData.uploadId)} />
                  {rowData.lineItems.total == 0 && rowData.IsNonPO === 0 ?
                    <span className="badge badge-danger">PO Cancelled</span>
                    : ""
                  }
                </div>
              )
            }
            else if (rowData.uploadId != null && roles[5]) {
              return (
                <div className="view-button" style={{ width: "150px" }}>
                  <a href={FILESERVER_ROOT_URL + "files/Documents/" + rowData.uploadId + "/download"} target="_blank" download>
                    <FontAwesomeIcon icon={"file-download"} color={rowData.uploadId == null || rowData.uploadId == 0 ? "grey" : "black"} title={rowData.uploadId == null || rowData.uploadId == 0 ? "Unavailable" : "Download"} size="lg" />
                  </a>
                  {rowData.lineItems.total == 0 && rowData.IsNonPO === 0 ?
                    <span className="badge badge-danger">PO Cancelled</span>
                    : ""
                  }
                </div>
              )
            }
            else if (rowData.uploadId != null && !roles[5] && !roles[15]) {
              return (
                <div className="view-button" style={{ width: "150px" }}>
                  <a href={FILESERVER_ROOT_URL + "files/Documents/" + rowData.uploadId + "/download"} target="_blank" download>
                    <FontAwesomeIcon icon={"file-download"} color={rowData.uploadId == null || rowData.uploadId == 0 ? "grey" : "black"} title={rowData.uploadId == null || rowData.uploadId == 0 ? "Unavailable" : "Download"} size="lg" />
                  </a>
                  {rowData.lineItems.total == 0 && rowData.IsNonPO === 0 ?
                    <span className="badge badge-danger">PO Cancelled</span>
                    : ""
                  }
                </div>
              )
            }
            else if (rowData.uploadId == null && !roles[5] && !roles[15]) {
              return (
                <div className="view-button" style={{ width: "150px" }}>
                  <FontAwesomeIcon icon={"stopwatch"} color={rowData.uploadId == null || rowData.uploadId == 0 ? "grey" : "black"} title={"Awaiting Upload"} size="lg" />
                  {rowData.lineItems.total == 0 && rowData.IsNonPO === 0 ?
                    <span className="badge badge-danger">PO Cancelled</span>
                    : ""
                  }
                </div>
              )
            }
          },
        },
        {
          title: 'Action',
          render: rowData => {
            return <>
              <div className="row text-center d-none d-sm-block headeralign">
                {rowData.PaymentTermId != 0 ?
                  <>
                    <Link to={{ pathname: '/PoAcceptanceTrail', state: { poId: rowData.PurchaseOrderId, poSAPId: rowData.POSAPId, PoAmount: rowData.POAmount } }}>
                      <FontAwesomeIcon icon={"eye"} color="black" title="View" size="lg" />
                    </Link>
                    < FontAwesomeIcon className="ml-2" icon={"info-circle"} cursor="pointer" color={"black"} title="View Info" size="lg" onClick={() => this.modalQAActivity(rowData)} />
                  </>
                  : null}
              </div>
            </>
          },
        },
      ];
    };
    if (this.props.poDetails.loading) {
      return (
        <Loading />
      )
    }
    return (


      <div className="Container-fluid">
        {/* ----------QA Activity Modal Start---------------- */}
        <Modal isOpen={this.state.modalQAActivity} className="modal-xl mr-2">
          <div className={"modal-bg" + (this.state.modalQAActivity === 'false' ? 'open' : '')}>
            <div className="modalheads">
              <ModalHeader HeaderStyle="modal-header">
                <div><h4 >Activity Details : {this.state.selectedItem.POSAPId}</h4></div>
                <button type="button" className="close" aria-label="Close" onClick={() => this.modalQAActivity()} >
                  <span aria-hidden="true">&times;</span>
                </button>
              </ModalHeader>
            </div>
            <div >
              <ModalBody Style="modal-body">
                <div className="row">
                  <div className="col">
                    <table border="1" className="table5 table" >
                      <thead>
                        <tr className="headerbar ">
                          <th>Action</th>
                          <th>Acted By</th>
                          <th>Acted On</th>
                          <th>Acted Time</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.qaActivity && this.props.qaActivity.length > 0 && this.props.qaActivity.map((item, index) =>
                          <tr key={index} className="rows headeralign">
                            <td>{item.ActionName}</td>
                            <td>{item.UploadedBy}</td>
                            <td>{item.CreatedOn ? dateFormater(item.CreatedOn) : '----'}</td>
                            <td>{item.CreatedOn ? formatTime(item.CreatedOn) : '----'}</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </ModalBody>
            </div>
          </div>
        </Modal>
        {/* ----------QA Activity Modal End---------------- */}
        {/* ----------Modal for PO Acceptance Requested Start-------------          */}
        <div>
          <Modal isOpen={this.state.modal} >
            <div className={"modal-bg" + (this.state.modal === 'false' ? 'open' : '')}>
              <div className="modalheads">
                <ModalHeader HeaderStyle="modal-header">
                  <div className="modal-text"><h4 >Detailed Status :</h4></div>
                  <Link to={{ pathname: '/RequestPOAcceptance', state: {} }}>
                    <button type="button" className="close" aria-label="Close" onClick={this.modal} >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </Link>
                </ModalHeader>
              </div>
              <div >
                <ModalBody Style="modal-body modalbodys">
                  <div>

                  </div>
                </ModalBody>
              </div>
              <div >
                <ModalFooter FooterStyle="modal-footer">
                  <div>
                    <button className="btn2 btn-sms1 rounded-pill mt-2 ml-4 float-right" onClick={this.modal} type="submit">OK</button>


                  </div>


                </ModalFooter>
              </div>
            </div>
          </Modal>
        </div>
        {/* ----------Modal for  PO Acceptance Requested End-------------          */}

        {/* ----------Modal for Adding Non PO Start-------------          */}
        <div>
          <Modal isOpen={this.state.nonPOModal} >
            <div className={"modal-bg" + (this.state.nonPOModal === false ? 'open' : '')}>
              <div className="modalheads">
                <ModalHeader HeaderStyle="modal-header">
                  <div className="modal-text"><h4 >Add New Non PO :</h4></div>
                  <button type="button" className="close" aria-label="Close" onClick={() => this.toggleNonPOModal()} >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </ModalHeader>
              </div>
              <div >
                <ModalBody Style="modal-body modalbodys">
                  <div className='row'>
                    <div className='col-6 pt-2'>
                      <b>PO Number :</b>
                    </div>
                    <div className='col-6 pt-2'>
                      <input type="text" className="form-control" placeholder="PO Number" name="POSAPId" min="1" onChange={(e) => this.handleChangeNonPoDetails(e)} value={this.state.nonPO.POSAPId || ""} />
                      <div style={{ color: "red", fontSize: "12px" }}>{this.state.nonPOError.POSAPId}</div>
                    </div>
                    <div className='col-6 pt-2'>
                      <b>PO Department :</b>
                    </div>
                    <div className='col-6 pt-2'>
                      <Select maxMenuHeight={500} placeholder="PO Department" name="poDepatment" value={this.state.SelectPODepartment} options={this.state.poDepartmentsArray} onChange={(e) => this.handleSelectPODepartment(e)} />
                      <div style={{ color: "red", fontSize: "12px" }}>{this.state.nonPOError.poDepartment}</div>
                    </div>
                    <div className='col-6 pt-2'>
                      <b>Payment Term :</b>
                    </div>
                    <div className='col-6 pt-2'>
                      <Select maxMenuHeight={500} placeholder="Payment Term" name="PaymentTermId" value={this.state.SelectPOPaymentTerm} options={this.state.poPaymentTermsArray} onChange={(e) => this.handleSelectPOPaymentTerm(e)} />
                      <div style={{ color: "red", fontSize: "12px" }}>{this.state.nonPOError.PaymentTermId}</div>
                    </div>
                    <div className='col-6 pt-2'>
                      <b>PO Amount :</b>
                    </div>
                    <div className='col-6 pt-2'>
                      <div className='input-group'>
                        <Select maxMenuHeight={500} className='modal-select' placeholder="Currency" name="Currency" value={this.state.SelectCurrencyArray} options={this.state.CurrencyArray} onChange={(e) => this.handleSelectCurrency(e)} />
                        <CurrencyInput allowNegativeValue={false} decimalScale="2" placeholder='PO Amount' className="form-control" name="POAmount" min="1" value={this.state.nonPO.POAmount || ""} onValueChange={(value, e) => this.handlvalueText(value, e)} />
                      </div>
                      <div style={{ color: "red", fontSize: "12px" }}>{this.state.nonPOError.Currency}</div>
                      <div style={{ color: "red", fontSize: "12px" }}>{this.state.nonPOError.POAmount}</div>
                    </div>
                    <div className='col-6 pt-2'>
                      <b>PO Date :</b>
                    </div>
                    <div className='col-6 pt-2'>
                      <input type="date" className="form-control" placeholder="PO Date" name="POCreationDate" onChange={(e) => this.handleChangeNonPoDetails(e)} value={this.state.nonPO.POCreationDate || ""} />
                      <div style={{ color: "red", fontSize: "12px" }}>{this.state.nonPOError.POCreationDate}</div>
                    </div>
                    <div className='col-6 pt-2'>
                      <b>Vendor Code :</b>
                    </div>
                    <div className='col-6 pt-2'>
                      <Select maxMenuHeight={500} className='' placeholder="Vendor Code" name="VendorSAPId" value={this.state.SelectVendorSapId} options={this.state.VendorSAPIdS} onChange={(e) => this.handleSelectVendorSAPID(e)} />
                      <div style={{ color: "red", fontSize: "12px" }}>{this.state.nonPOError.VendorSAPId}</div>
                    </div>
                    <div className='col-6 pt-2'>
                      <b>Vendor Name :</b>
                    </div>
                    <div className='col-6 pt-2'>
                      <p>{this.state.SelectVendorSapId && this.state.SelectVendorSapId.length ? this.state.SelectVendorSapId[0].VendorName : ""}</p>
                    </div>
                    <div className='col-6 pt-2'>
                      <b>Location :</b>
                    </div>
                    <div className='col-6 pt-2'>
                      <input type="text" className="form-control" placeholder="Location" name="Location" onChange={(e) => this.handleChangeNonPoDetails(e)} value={this.state.nonPO.Location || ""} />
                      <div style={{ color: "red", fontSize: "12px" }}>{this.state.nonPOError.Location}</div>
                    </div>
                    {/* <div className='col-6 pt-2'>
                      <b>Purchase Group :</b>
                    </div>
                    <div className='col-6 pt-2'>
                      <input type="text" className="form-control" placeholder="Purchase Group" name="PurchaseGroup" onChange={(e) => this.handleChangeNonPoDetails(e)} value={this.state.nonPO.PurchaseGroup || ""} />
                      <div style={{ color: "red", fontSize: "12px" }}>{this.state.nonPOError.PurchaseGroup}</div>
                    </div>
                    <div className='col-6 pt-2'>
                      <b>Purchase Group Description :</b>
                    </div>
                    <div className='col-6 pt-2'>
                      <input type="text" className="form-control" placeholder="Purchase Group Description" name="PurchaseGroupDescription" onChange={(e) => this.handleChangeNonPoDetails(e)} value={this.state.nonPO.PurchaseGroupDescription || ""} />
                      <div style={{ color: "red", fontSize: "12px" }}>{this.state.nonPOError.PurchaseGroupDescription}</div>
                    </div> */}
                    <div className='col-6 pt-2'>
                      <b>Inco Terms :</b>
                    </div>
                    <div className='col-6 pt-2'>
                      <Select maxMenuHeight={500} placeholder="Inco Terms" name="incoTerms" value={this.state.SelectInfoTrems} options={this.state.infoTermsArray} onChange={(e) => this.handleSelectInfoTerms(e)} />
                      <div style={{ color: "red", fontSize: "12px" }}>{this.state.nonPOError.incoTerms}</div>
                    </div>
                  </div>
                </ModalBody>
              </div>
              <div >
                <ModalFooter FooterStyle="modal-footer">
                  <div>
                    <button className="btn2 btn-sms3 rounded-pill mt-2 ml-4 float-right" onClick={() => this.toggleNonPOModal()} type="submit">Cancel</button>
                    <button className="btn2 btn-sms1 rounded-pill mt-2 ml-4 float-right" onClick={() => this.handleSubmitNonPODetails()} tpye="submit">Add</button>
                  </div>


                </ModalFooter>
              </div>
            </div>
          </Modal>
        </div>
        {/* ----------Modal for Adding Non PO End-------------          */}

        {/*----------File version start  */}
        {this.state.uploadedId && this.state.OpenVersionmodal && <FileVersionModal OpenVersionmodal={this.state.OpenVersionmodal} uploadedId={this.state.uploadedId} OpenVersionModal={(uploadId) => this.OpenVersionmodal(uploadId)} />}
        {/*----------File version end  */}

        {/*----------Document comment-------------- */}
        {
          varDocumentId ? (<POCommentPopUp action={this.state.POCommentPopUpModal} togglePOCommentPopUpModal={(e) => this.togglePOCommentPopUpModal(e)} DocumentId={varDocumentId} varPoId={varPoId} path='/ExpeditingPOAcceptanceTrail' />) : null
        }
        {/*----------Document Comment end  */}

        {/* ---- Version upload popup----- */}
        {this.state.OpenVersionUploadPopUp && <PoDocumentRevisePopUp OpenVersionUploadPopUp={this.state.OpenVersionUploadPopUp} uploadedId={this.state.uploadedId} OpenSaveVersionFilePopUp={(rowData, refresh) => this.OpenSaveVersionFilePopUp(rowData, refresh)} poRowData={this.state.poRowData} />}
        {/* ---- End of Version upload pop --- */}

        <RejectPOAcceptance action={this.state.ReviseModal} flagR={this.state.flagR} poID={this.state.poId} uploadID={this.state.uploadId} datasync={this.dataSync} setLoader={(e) => this.setLoader(e)} toggleReviseModal={(e) => this.toggleReviseModal(e)} path='/PoAcceptanceTrail' />


        <div className="Container-fluid p-4" style={{ opacity: this.state.opacity }}>
          <div className="row ">
            <div className="col-3">
              <div className="header"><b>Purchase Orders</b></div>
            </div>
            <div className="col-4 mt-2">
              {roles[15] ?
                <button className="btn2 btn-sms1 rounded-pill float-right" type="button" disabled={this.state.checkedArray.length < 1 ? true : false} onClick={this.requestPoAcceptance}> Request PO Acceptance </button>
                : null}
              {roles[15] && this.props.history.location.pathname && (this.props.history.location.pathname).includes('hr-admin-purchase-orders') ?
                <button className="btn2 btn-sms1 rounded-pill float-right" type="button" onClick={() => this.toggleNonPOModal()}> Add Non PO </button>
                : null}
              {/* <CSVLink className="btn2 btn-sms1 float-right rounded-pill" data={this.state.csvData} filename={'Purchase.csv'}>export</CSVLink> */}
            </div>
            <div className="col-5 xs={last} pt-2" style={{ paddingRight: 30 }}>
              {/* <SearchBar placeholder="Search" value={this.state.searchTerm} searchInputHandler={(e) => { this.handleISearch(e) }} searchClick={this.handleSearching} label="Search" btnName="" /> */}
              <SearchBar placeholder="Search" value={this.state.searchTerm} searchInputHandler={(e) => { this.handleISearch(e) }} searchClick={this.handleSearching} label="Search" toggleFilter={this.toggleFilter} clearFilter={this.clearFilter} filter={true} clear={true} btnName="" ShowSearchFor={true} searchForOptions={this.state.searchForOptions} searchForItem={this.state.searchForItem} SelectSearchForHandler={this.handleSelectSearchFor} />
            </div>
          </div>

          {this.state.isShowFilter ?
            <div className="row justify-content-between pb-3 pt-3 m-0 border-radius-modal filter-data pr-2 pl-2">
              {/* <div className="col">
                <Select maxMenuHeight={500} placeholder="Expeditor" isMulti value={this.state.employees} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalemployees} onChange={(e) => this.handleSelectEmployees(e)} />
              </div> */}
              <div className="col">
                <Select maxMenuHeight={500} placeholder="Project No." isMulti value={this.state.WBSCode} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalwbsno} onChange={(e) => this.handleSelectWBS(e)} />
              </div>
              <div className="col">
                <Select maxMenuHeight={500} placeholder="Vendor" isMulti value={this.state.VendorName} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalvendorlist} onChange={(e) => this.handleSelectVendor(e)} />
              </div>
              <div className="col">
                <Select maxMenuHeight={500} placeholder="Plant" isMulti value={this.state.PlantCode} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalplantcode} onChange={(e) => this.handleSelectPlantCode(e)} />
              </div>
              <div className="col">
                <Select maxMenuHeight={500} placeholder="PO No." isMulti value={this.state.POSAPId} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalpos} onChange={(e) => this.handleSelectPO(e)} />
              </div>
              <div className="col">
                <Select maxMenuHeight={500} placeholder="Purchase Group" isMulti value={this.state.PurchaseGroup} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalPurchaseGroup} onChange={(e) => this.handleSelectPurchaseGroup(e)} />
              </div>
              <div className="col">
                <InputGroup>
                  <FormControl className='outline-primary' type="text" readOnly placeholder="PO Dt." />
                  <InputGroup.Append>
                    <Button className="custom-drop-arrow" onClick={() => this.togglePoDocDate()} variant="outline-secondary"><FontAwesomeIcon icon={"chevron-down"} size="xs" /></Button>
                  </InputGroup.Append>
                </InputGroup>
                {this.state.isShowPoDocDate ?
                  <>
                    <label>Start Date</label>
                    <Form.Control className="width-90" type="date" onChange={(e) => { this.handlepoDocStartDate(e) }} placeholder="Start Date" value={this.state.poDocStartDate} />
                    <label>End Date</label>
                    <Form.Control className="width-90" type="date" onChange={(e) => { this.handlepoDocEndDate(e) }} id={`inspectionEndDate-datepicker`} name={`inspectionEndDate-datepicker`} placeholder="inspection End Date" value={this.state.poDocEndDate} />
                  </>
                  : null}
              </div>
            </div>
            : null}

          <div className="row sticky ">
            <div className="col wrap  ">
              {this.state.loading ?
                <Loading />
                :
                <TableComp
                  cols={tableConstants()}
                  data={currentTodos} />
              }
            </div>
          </div>
        </div>
        <div className="float-right">
          <hr></hr>
          <PaginationComponent filteredTodos={filteredTodos} currentPage={this.state.currentPage} posPerpage={posPerpage} totalPos={this.state.totalPos} handleClick={this.handleClick} handleSelectPoPerPage={this.handleSelectPoPerPage} showPosPerpage={true} />
          <hr></hr>
        </div>
      </div>
    )
  }
}








const mapStateToProps = (state) => ({
  supplier: state.supplier,
  poDetails: state.poDetails,
  filterList: state.masterReducer.filterList,
  qaActivity: state.poDetails.qaActivity,
  nonPODetails: state.poDetails.nonPODetails,
  nonPODetailsError: state.poDetails.nonPODetailsError,

})
export default connect(mapStateToProps, {
  getSupplierPOs,
  getPOPurchaseOrders,
  UpdatePoStatusforPOacceptanceRequest, GetDocumentsForAdvance,
  uploadFileGeneric,
  postDocumentIDForPODetailsDocument,
  getPOSearch,
  getSearchedPO,
  GetFilterList,
  GetExcellExportData,
  getProjectAllocationByUserId,
  getQAActivity,
  postNonPODetails,
})(Dashboard)
